import styled from 'styled-components';

const WeSpinTable = styled.table`
	td {
		border-bottom: 1px solid rgba(var(--font-supportive), 0.2);
	}
`;

export default WeSpinTable;
